import type App from "../index";
import { ScrollDirection, ScrollHandler } from "../classes/scroll-manager";
import { getEl } from "../helpers";


export default class StickyProgress implements ScrollHandler
{

	elDocProgress:Element;

	constructor(app: App) {
		app.scroller.addScrollTrigger( '#slb-report', this, 1, 0, 1, -1);
		this.elDocProgress = getEl(".document-progress");
	}

	onEnteredView(dir: ScrollDirection)
	{

	}

	public onScroll(direction: ScrollDirection, progress?: number, oldProgress?: number)
	{
		if (!progress) progress = 0;
		// @ts-ignore
		this.elDocProgress.style.width = progress*100 + "%";
	}

	onExitedView(direction: ScrollDirection): any {
	}

}
